module.exports = __webpack_public_path__ + "static/3.21a5925d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/3.png
// module id = 870
// module chunks = 69039249851653 261756379115546